import { BaseFetch } from "../main-model"
export default class AbilityToStudyModel extends BaseFetch {
  getAbilityToStudyBy = (data) =>
    this.authFetch({
      url: "ability-to-study/getAbilityToStudyBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getAbilityToStudyById = (data) =>
    this.authFetch({
      url: "ability-to-study/getAbilityToStudyById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAbilityToStudyById = (data) =>
    this.authFetch({
      url: "ability-to-study/updateAbilityToStudyById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAbilityToStudy = (data) =>
    this.authFetch({
      url: "ability-to-study/insertAbilityToStudy",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAbilityToStudyById = (data) =>
    this.authFetch({
      url: "ability-to-study/deleteAbilityToStudyById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getAbilityToStudyPP6By = (data) =>
    this.authFetch({
      url: "ability-to-study/getAbilityToStudyPP6By",
      method: "POST",
      body: JSON.stringify(data),
    })
}
